import { render, staticRenderFns } from "./CustomUploadImg.vue?vue&type=template&id=62d9b71c&scoped=true"
import script from "./CustomUploadImg.vue?vue&type=script&lang=js"
export * from "./CustomUploadImg.vue?vue&type=script&lang=js"
import style0 from "./CustomUploadImg.vue?vue&type=style&index=0&id=62d9b71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d9b71c",
  null
  
)

export default component.exports